import _sfc_main from "./GenericErrorText2.mjs";
/* empty css                   */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const GenericErrorText = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-153f374b"]]);
export {
  GenericErrorText as default
};
//# sourceMappingURL=GenericErrorText.mjs.map
